<template>
  <section class="event-card">
    <router-link :to="`/activity/${item.id}/detail`">
      <div class="image">
        <img :src="item.thumb | imageUrl('',446,594)" alt />
        <span
          :class="{active:item.status===5,ended:item.status===4,unStart:item.status===2}"
        >{{statusText[item.status]}}</span>
      </div>
      <div class="bottom">
        <p>{{item.title}}</p>
        <span>{{item.holdStartTime|formatDate('YYYY.MM.DD') }} - {{item.holdEndTime|formatDate('YYYY.MM.DD')}}</span>
      </div>
    </router-link>
  </section>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      statusText: {
        "-1": "已删除",
        "1": "待审核",
        "2": "即将开始",
        "3": "审核未通过",
        "4": "已结束",
        "5": "进行中"
      }
    };
  }
};
</script>

<style lang="stylus" scoped>
.event-card {
  .image {
    position: relative;

    img {
      width: 223px;
      height: 297px;
    }

    span {
      position: absolute;
      width: 88px;
      height: 30px;
      border: 1px solid #2026CC;
      bottom: -15px;
      font-size: 14px;
      left: 0;
      background: #fff;
      line-height: 30px;
      text-align: center;

      &.active {
        color: #2026CC;
      }

      &.ended {
        color: #666;
        border-color: #666;
      }

      &.unStart {
        color: #FE5630;
        border-color: #FE5630;
      }
    }

    &:hover {
      span {
        background: #2026CC;
        color: #fff;

        &.ended {
          background: #666;
          color: #fff;
        }

        &.unStart {
          background: #FE5630;
          color: #fff;
        }
      }
    }


  }

  .bottom {
    padding-top: 30px;

    p {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 22px;
      color: #0A0A0A;
    }

    span {
      font-size: 14px;
      font-family: NunitoSans-Regular, NunitoSans;
      line-height: 19px;
      color: #999;
      padding-top: 10px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/ActivityCard.vue